export const CREDIT_STATUS_CLEARED = 'CREDIT_STATUS_CLEARED';

export const creditStatusCleared = payload => dispatch =>
  dispatch({
    type: CREDIT_STATUS_CLEARED,
    payload,
  });
